import AppLayout from 'src/containers/app-layout'
import ForgotPasswordContainer from 'src/containers/forgot-password'

export default function ForgotPasswordPage() {
  return (
    <>
      <ForgotPasswordContainer />
    </>
  )
}

ForgotPasswordPage.getLayout = (page: React.ReactElement) => {
  return (
    <AppLayout minWidth={false} noMargin>
      {page}
    </AppLayout>
  )
}
